import { Locale } from '@ps-smart-cp/ppfw-client';

const characterCodeNameConfig = {
  iso88591: new Map([
    [Locale.ja, 'ISO_8859_1 ISO　8859-1'],
    [Locale.en, 'ISO_8859_1 ISO　8859-1'],
  ]),
  ms932: new Map([
    [Locale.ja, 'MS932 日本語(Windows-31J)'],
    [Locale.en, 'MS932 Japanese(Windows-31J)'],
  ]),
  utf16: new Map([
    [Locale.ja, 'UTF-16 UTF-16'],
    [Locale.en, 'UTF-16 UTF-16'],
  ]),
  utf8: new Map([
    [Locale.ja, 'UTF-8 UTF-8'],
    [Locale.en, 'UTF-8 UTF-8'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { characterCodeNameConfig };
